import { LayoutModule } from '@angular/cdk/layout';
import { CommonModule,DatePipe,registerLocaleData } from '@angular/common';
import { HttpClientJsonpModule,HttpClientModule } from '@angular/common/http';
import localeDe from '@angular/common/locales/de';
import { CUSTOM_ELEMENTS_SCHEMA,DEFAULT_CURRENCY_CODE,ErrorHandler,LOCALE_ID,NgModule } from '@angular/core';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatNativeDateModule,MAT_DATE_FORMATS,MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatLegacyDialogModule as MatDialogModule,MAT_LEGACY_DIALOG_DEFAULT_OPTIONS as MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/legacy-dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacySliderModule as MatSliderModule } from '@angular/material/legacy-slider';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyTooltipModule as MatTooltipModule,MAT_LEGACY_TOOLTIP_DEFAULT_OPTIONS as MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/legacy-tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from "@angular/router";
import { FaIconLibrary,FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { AngularImageViewerModule } from '@hreimer/angular-image-viewer';
import { Store } from '@ngrx/store';
import * as Sentry from "@sentry/angular";
import { NgClickOutsideDirective } from 'ng-click-outside2';
import { DropzoneModule,DROPZONE_CONFIG } from 'ngx-dropzone-wrapper';
import { MarkdownModule,MarkedOptions } from 'ngx-markdown';
import { ToastrModule } from 'ngx-toastr';
import { SimplebarAngularModule } from 'simplebar-angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BurgerButtonWrapperComponent } from './burger-button-wrapper/burger-button-wrapper.component';
import { HomeDashboardComponent } from './components/dashboard/home-dashboard.component';
import { ServiceButtonsComponent } from './components/dashboard/services/service-buttons/service-buttons.component';
import { ServicesComponent } from './components/dashboard/services/services.component';
import { TimeTrackerKagetecComponent } from './components/dashboard/services/time-tracker-kagetec/time-tracker-kagetec.component';
import { WeatherComponent } from './components/dashboard/weather/weather.component';
import { EmailDialogComponent } from './components/detail-views/detail-event/email-dialog/email-dialog.component';
import { BreadcrumbsComponent } from './components/header/breadcrumbs/breadcrumbs.component';
import { HeaderComponent } from './components/header/header.component';
import { LoginComponent } from './components/login/login.component';
import { LogoutComponent } from './components/logout/logout.component';
import { SearchReturnComponent } from './components/search/search-return/search-return.component';
import { SearchComponent } from './components/search/search.component';
import { SideNavBarComponent } from './components/side-nav-bar/side-nav-bar.component';
import { TagChipAutocompleteModule } from './components/templates/tag-chip-autocomplete/tag-chip-autocomplete.module';
import { TextareaModule } from './components/templates/textarea/textarea.module';
import { VerifyOrderComponent } from './components/verify-order/verify-order.component';
import { DaveCalendarModule } from './dave-calendar/dave-calendar.module';
import { DaveCommissionModule } from './dave-commission-module/dave-commission.module';
import { DaveDataStateModule } from './dave-data-module/dave-data-state.module';
import { State } from './dave-data-module/State';
import { DaveDmsModule } from './dave-dms-module/dave-dms.module';
import { DaveDocumentEditorModule } from './dave-document-editor-module/dave-document-editor.module';
import { DaveDoubleIconModule } from './dave-double-icon/dave-double-icon.module';
import { EmailEditorComponent } from './dave-email-module/components/email-editor/email-editor.component';
import { DaveEmailModule } from './dave-email-module/dave-email.module';
import { DaveFileExplorerModule } from './dave-file-explorer/dave-file-explorer.module';
import { DaveFilePreviewDialogModule } from './dave-file-preview-dialog/dave-file-preview-dialog.module';
import { DaveHistoryModule } from './dave-history-module/dave-history.module';
import { DaveImageSliderComponent } from './dave-image-slider/dave-image-slider.component';
import { DaveListCardModule } from './dave-list-card/dave-list-card.module';
import { DaveLoadingModule } from './dave-loading/dave-loading.module';
import { DaveNewsModule } from './dave-news/dave-news.module';
import { NewReportDialogModule } from './dave-reports/components/new-report-dialog/new-report-dialog.module';
import { DaveSelectUserModule } from './dave-select-user/dave-select-user.module';
import { DaveTimeTrackerModule } from './dave-time-tracker/dave-time-tracker.module';
import { AppButtonModule } from './dave-utils-module/app-button-module/app-button.module';
import { AppDialogModule } from './dave-utils-module/app-dialog-module/app-dialog.module';
import { DaveSharedComponentsModule } from './dave-utils-module/dave-shared-components-module/dave-shared-components.module';
import { PipesModule } from './dave-utils-module/dave-shared-components-module/pipes/pipes.module';
import { IconPipeModule } from './dave-utils-module/icon-pipe/icon-pipe.module';
import { SelectSearchModule } from './dave-utils-module/select-search/select-search.module';
import { AutofocusModule } from './directives/autofocus/autofocus.module';
import { EInvoiceViewDialogComponent } from './e-invoice/components/e-invoice-view-dialog/e-invoice-view-dialog.component';
import { EInvoiceViewComponent } from './e-invoice/components/e-invoice-view/e-invoice-view.component';
import { appMatDialogDefaultConfig,DEFAULT_DROPZONE_CONFIG,myCustomTooltipDefaults,MY_DATE_FORMAT } from './helper/helper';
import { ResourceDispoModule } from './resource-dispo/resource-dispo.module';
import { SessionService } from './services/session.service';
import { MAT_CHECKBOX_DEFAULT_OPTIONS, MatCheckboxDefaultOptions } from '@angular/material/checkbox';
import { MAT_RADIO_DEFAULT_OPTIONS, MatRadioDefaultOptions } from '@angular/material/radio';
import { FlutterBridgeService } from './flutter-bridge/flutter-bridge-service';
import { HintIconComponent } from './hint-icon/hint-icon.component';

@NgModule({
    declarations: [
        AppComponent,
        HomeDashboardComponent,
        HeaderComponent,
        LoginComponent,
        LogoutComponent,
        ServicesComponent,
        WeatherComponent,
        SearchComponent,
        SearchReturnComponent,
        BreadcrumbsComponent,
        VerifyOrderComponent,
        EmailDialogComponent,
        DaveImageSliderComponent,
        TimeTrackerKagetecComponent,
        ServiceButtonsComponent,
        EInvoiceViewDialogComponent,
    ],
    imports: [
        CommonModule,
        ResourceDispoModule, // todo wech machen
        NgClickOutsideDirective,
        BrowserModule,
        AngularImageViewerModule, // AngularImageViewerModule muss hier importiert werden, da es BrowserModule importiert
        MatGridListModule,
        MatChipsModule,
        AppRoutingModule,
        FontAwesomeModule,
        MatInputModule,
        MatDatepickerModule,
        MatExpansionModule,
        MatIconModule,
        MatMenuModule,
        MatNativeDateModule,
        MatRadioModule,
        MatSelectModule,
        MatSidenavModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatSortModule,
        MatTooltipModule,
        HttpClientModule,
        MatCheckboxModule,
        MatMomentDateModule,
        BrowserAnimationsModule,
        MatDividerModule,
        MatCardModule,
        MatButtonModule,
        DaveDocumentEditorModule,
        MatChipsModule,
        LayoutModule,
        MatTabsModule,
        MatTableModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientJsonpModule,
        DropzoneModule,
        ToastrModule.forRoot({ extendedTimeOut: 1000, timeOut: 5000 }),
        MatProgressSpinnerModule,
        MarkdownModule.forRoot({
            markedOptions: {
                provide: MarkedOptions,
                useValue: {
                    gfm: true,
                    tables: true,
                    breaks: true,
                    pedantic: false,
                    sanitize: false,
                    smartLists: true,
                    smartypants: false,
                },
            },
        }),
        MatListModule,
        PipesModule,
        MatAutocompleteModule,
        SimplebarAngularModule,
        MatTableModule,
        DaveDataStateModule,
        DaveSharedComponentsModule,
        MatDialogModule,
        RouterModule,
        IconPipeModule,
        AppButtonModule,
        DaveHistoryModule,
        SelectSearchModule,
        TagChipAutocompleteModule,
        DaveDmsModule,
        DaveCommissionModule,
        AppDialogModule,
        NewReportDialogModule,
        DaveFileExplorerModule,
        TextareaModule,
        DaveNewsModule,
        DaveEmailModule,
        EmailEditorComponent,
        // CalendarModule.forRoot({ provide: DateAdapter, useFactory: momentAdapterFactory }),
        DaveTimeTrackerModule,
        MatBadgeModule,
        DaveFilePreviewDialogModule,
        DaveCalendarModule,
        DaveLoadingModule,
        DaveSelectUserModule,
        SideNavBarComponent,
        BurgerButtonWrapperComponent,
        DaveListCardModule,
        AutofocusModule,
        DaveDoubleIconModule,
        HintIconComponent,
        EInvoiceViewComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [
        DatePipe,
        // {
        //     provide: HttpService,
        //     // useFactory: (httpClient: HttpClient) =>
        //     //     httpServiceFactory(httpClient, HTTP_SERVICE_CONFIG),
        //     deps: [HttpClient],
        // },
        { provide: MAT_DATE_LOCALE, useValue: 'de-DE' },
        { provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' },
        {
            provide: LOCALE_ID,
            deps: [SessionService],
            useFactory: (sessionService: SessionService) => sessionService.getLocale(),
        },
        {
            provide: DROPZONE_CONFIG,
            useValue: DEFAULT_DROPZONE_CONFIG,
        },
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({
                showDialog: false,
            }),
        },
        { provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: myCustomTooltipDefaults },
        { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMAT },
        { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: appMatDialogDefaultConfig },
        { provide: MAT_CHECKBOX_DEFAULT_OPTIONS, useValue: { color: 'primary' } as MatCheckboxDefaultOptions },
        { provide: MAT_RADIO_DEFAULT_OPTIONS, useValue: { color: 'primary' } as MatRadioDefaultOptions },
    ],
    bootstrap: [AppComponent],
    // entryComponents: [EmailDialogComponent],

    exports: [EmailDialogComponent, HeaderComponent],
})
export class AppModule {
    constructor(protected store: Store<State>, library: FaIconLibrary, private flutterBridge: FlutterBridgeService) {
        library.addIconPacks(fas, far, fab);
        registerLocaleData(localeDe);
    }
}
